module.exports = __webpack_public_path__ + "img/institutionIcon.68c95dfd.svg";